import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  empid: null,
  name: null,
  image: null,
  role: null,
  permissions: null,
  token: null,
  isTestUser: false,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.empid = action.payload.empid;
      state.name = action.payload.name;
      state.permissions = action.payload.permissions;
      state.token = action.payload.token;
      state.image = action.payload.image;
      state.role = action.payload.role;
      state.isTestUser = action.payload.isTestUser || false;
    },
    clearUser: (state) => {
      state.empid = null;
      state.name = null;
      state.permissions = null;
      state.token = null;
      state.image = null;
      state.role = null;
      state.isTestUser = false;
    },
  },
});

export const { setUser, clearUser } = userSlice.actions;
export default userSlice.reducer;
